define('presentation/common/routeToModal/facades/routeToCallQueueFacade',['common/promises/promiseFactory',
    'common/storage/commonState',
    'externalDependencies/clientWebSocket',
], function() {

    const callQueueSocket = require('externalDependencies/clientWebSocket').forApplication("callQueue");
    const _commonState = require('common/storage/commonState');

    let _promiseFactory = null;

    const _getCallQueues = () => {
        return _promiseFactory.defer((promise) => {
            callQueueSocket.send("getCallQueueList", {}, (result, err) => {
                if (err) {
                    promise.reject(new Error(err));
                    return;
                }

                const callQueues = result.callQueues.map((callQueue) => {
                    return {
                        id: callQueue.accountCallQueueId,
                        name: callQueue.name,
                        type: _commonState.types.callQueue
                    };
                });

                promise.resolve(callQueues);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        let self = this;

        self.init = _init;
        self.getCallQueues = _getCallQueues;
    };
});

